<template>
  <nav>
    <v-row
      class="fill-height loginBackground"
      align="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="6"
        offset-sm="2"
        offset-md="3"
        align="center"
      >
        <v-card
          max-width="600"
          elevation="0"
          rounded="xxl"
          color="background"
        />
      </v-col>
    </v-row>
  </nav>
</template>
<script>
import i18n from '../../plugins/i18n'
import { loginAuth, loginSaml } from '../../auth/auth.js'
import { getSpaceByURL } from '../../api/spaceApi'
import { getUserProfile } from '../../api/userApi'

export default {
    data(){
        return{
            token: '',
            space: window.location.host.split('.')[0],
            role: localStorage.space ? JSON.parse(localStorage.space).role : null,
            logo: localStorage.space ? JSON.parse(localStorage.space).logo : null,
            idps: localStorage.space ? JSON.parse(localStorage.space).idps : [],
            focusNext(elem) {
                const currentIndex = Array.from(elem.form.elements).indexOf(elem);
                elem.form.elements.item(
                    currentIndex < elem.form.elements.length - 1 ?
                    currentIndex + 1 :
                    0
                ).focus();
            },
         }
    },
    created() {
        if(this.$route.query.state) {
          if (this.$route.query.state == 'failed') {
            this.$router.push({name: 'CustomLogin', params: {samlServerError: true}})
          } else if (this.$route.query.state == 'user_deleted') {
            this.$router.push({name: 'CustomLogin', params: {samlUserDeleted: true}})
          } else if (this.$route.query.state == 'email_taken') {
            this.$router.push({name: 'CustomLogin', params: {samlEmailTaken: true}})
          } else {
            loginSaml(this.$route.query.state)
            this.getUserProfile(this.$route.query.state)
          }
        }
    },
    methods: {
        async getUserProfile(token){
          try {
            const response = await getUserProfile(token)
            if(response.status == 200) {
              loginAuth(token, response.data.data)
              
              i18n.locale = response.data.data.attributes.language && response.data.data.attributes.language.trim()
              window.$cookies.set("language", i18n.locale, 0, null, process.env.VUE_APP_DOMAIN)

              if(this.$route.params.signature){
                  this.$router.push({name: 'JoinSpace', params: {signature: this.$route.params.signature}})
              } else {
                try {
                  const response_space = await getSpaceByURL(this.space)
                  if(response_space.status){
                    if(response_space.status == 200) {
                      localStorage.space = JSON.stringify(response_space.data.data.attributes)
                      this.$store.dispatch("getSubscribedPlan", response_space.data.data).catch(error => {
                        if (error.response.status == 403) {
                          this.$router.push({name: 'PageAccessDenied'})
                        }
                        if (error.response.status == 404) {
                          this.$router.push({name: 'PageNotFound'})
                        }
                      })
                      
                      this.$store.dispatch("setBrokenWorkflow", response_space.data.data.attributes.workflow_warning)
                     
                      if (this.$route.query.referer) {
                        window.location.href = process.env.VUE_APP_PROTOCOL + "://" + this.$route.query.referer
                      }

                      const role = response_space.data.data.attributes.role
                      if(role == 'participant' || role == 'guest'){
                        this.$router.push(this.$route.query.redirect_after || '/dashboard-participant')
                      } else {
                        this.$router.push(this.$route.query.redirect_after || '/')
                      }
                    }
                  }
                } catch (e) {
                  if(e.response){
                    if(e.response.status == 403){
                      this.$router.push('/forbidden')
                    }
                  }
                }
              }
            }
          } catch (e) {
          if(e.response){
      
            if(e.response.status == 403){
                this.$router.push('/forbidden')
              }
            }
          }
        },
    },
}
</script>
